module.exports = new __parcel__URL__("icon-faq.34741166.svg").toString();